<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="pt01">
<h1 class="pn"><a class="page" id="p1"></a><a class="page" id="pxx"></a><a class="xref" href="#/chidruckmanjacobs0007#toc"><span class="sm">PART</span> <span class="sm">I</span></a></h1>
<h1 class="pt">Political Representation and Presidential Manipulation</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-druckman-jacobs-0009.vue?1174e409